import React, { useState, ReactNode } from 'react';
import { ListGroup } from 'flowbite-react';

interface MenuDropdownItem {
  label: string;
  icon?: ReactNode;
  onClick: () => void;
  className?: string;
}

interface MenuDropdownProps {
  trigger: ReactNode;
  items: MenuDropdownItem[];
  dropdownWidth?: string;
}

export const MenuDropdown: React.FC<MenuDropdownProps> = ({ 
  trigger, 
  items, 
  dropdownWidth = "w-40 sm:w-44" 
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <div 
        onClick={() => setIsOpen(!isOpen)}
        className="cursor-pointer"
      >
        {trigger}
      </div>

      {isOpen && (
        <>
          <div className={`absolute right-0 top-full mt-1 z-50 ${dropdownWidth} bg-light-surfacePrimary dark:bg-slate-800 rounded-md shadow-lg border border-light-border-default dark:border-gray-700 overflow-hidden`}>
            <ListGroup className="bg-light-surfacePrimary dark:bg-slate-800 text-right border-none">
              {items.map((item, index) => (
                <ListGroup.Item
                  key={index}
                  onClick={() => {
                    item.onClick();
                    setIsOpen(false);
                  }}
                  className={`hover:bg-light-interactive-hover dark:hover:bg-slate-700 border-none cursor-pointer transition-colors duration-200 ${item.className || ''}`}
                  theme={{
                    link: {
                      base: "flex justify-between items-center focus:outline-none w-full py-2 px-4 border-none text-light-text-primary dark:text-white",
                    },
                  }}
                >
                  <span>{item.label}</span>
                  {item.icon && <span className="ml-2">{item.icon}</span>}
                </ListGroup.Item>
              ))}
            </ListGroup>
          </div>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          ></div>
        </>
      )}
    </div>
  );
};
